// CandidateLayoutContext.js
import React, { createContext, useContext } from "react";

const CandidateLayoutContext = createContext();
const ClientLayoutContext = createContext();

export const useCandidateLayout = () => useContext(CandidateLayoutContext);
export const useClientLayout = () => useContext(ClientLayoutContext);

export const CandidateLayoutProvider = ({ value, children }) => (
  <CandidateLayoutContext.Provider value={value}>
    {children}
  </CandidateLayoutContext.Provider>
);



export const ClientLayoutProvider = ({ value, children }) => (
  <ClientLayoutContext.Provider value={value}>
    {children}
  </ClientLayoutContext.Provider>
);